import styled from 'styled-components'

export default styled.span`
  position: relative;
  padding-left: ${props => props.showColorSwatch ? '25px' : '0'};
  display: block;

  .shadetext {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    color: rgb( 103, 103, 103);
    font-size: 11px;
    line-height: 16px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/ColorOptionLabel.js